import React,{useState, useEffect} from 'react';

function Translate(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [translations, setTranslations] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const lng = props.lng;
  const text = props.text;
  const translationBack = props.translationBack;
  const appState = props.appState;
  const setTranslation = props.setTranslation;
  const deeplKey = props.deeplKey;

  useEffect(() => {
    if(text.length > 1 && appState === 'translation'){
      setIsLoaded(false);
      setTranslations('');
      fetch(`https://api.deepl.com/v2/translate?auth_key=${deeplKey}&text=${text}&source_lang=de&target_lang=${lng}`)
        .then(res => {
          if(!res.ok){
            console.log(res);
            setErrorCode('ERROR: ' + res.status)
          };
          return res.json()
        })
        .then(
          (result) => {
            console.log('answer from deepl', result);
            setIsLoaded(true);
            if (result.translations) {
              setTranslations(result.translations[0].text);
            }else if((result.message)){
              setTranslations(result.message);
            }
          },
          (error) => {
            console.log('error', error);
            setIsLoaded(true);
          }
        )
      }
  }, [text, lng, appState, deeplKey])


  useEffect(() => {
    if(translations.length > 0){
      setTranslation(translations);
    }
  },[translations, setTranslation])


  if(text !== '' && appState !== 'show' && appState !== 'wait' && translationBack === ''){
    if (!isLoaded) {
      return null //<p className="status">Übersetze...</p>
    } else {
      return (<p className="translation">/ {translations} {errorCode}</p>)
    }
  } else {
      return null;
  }
}



export default Translate;
